import type { AuditLogListOptions, IAuditLogRepository } from '../repositories/IAuditLogRepository.js';

interface Deps { auditLogRepository: IAuditLogRepository; }

export function createListAuditLogUseCase({ auditLogRepository }: Deps) {
  return (options: AuditLogListOptions) => auditLogRepository.list(options);
}
